'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _currentBoardIdConstants = require('./currentBoardIdConstants');

var _currentUserConstants = require('../../user/currentUserConstants');

// Constants
var initialState = _currentBoardIdConstants.UNINITIALISED;

var handleCurrentUserSet = function handleCurrentUserSet(state, action) {
    return (
        // Only update the current board ID if it hasn't already been set
        state === _currentBoardIdConstants.UNINITIALISED ? action.user.lastViewedBoard || action.user.rootBoardId : state
    );
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _currentBoardIdConstants.CURRENT_BOARD_ID_SET:
            return action.boardId;
        case _currentUserConstants.CURRENT_USER_SET:
            return handleCurrentUserSet(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/currentBoardId/currentBoardIdReducer.js
// module id = 2039
// module chunks = 0